import { render, staticRenderFns } from "./LinkMetadataCover.vue?vue&type=template&id=2030414e&scoped=true"
import script from "./LinkMetadataCover.vue?vue&type=script&lang=js"
export * from "./LinkMetadataCover.vue?vue&type=script&lang=js"
import style0 from "./LinkMetadataCover.vue?vue&type=style&index=0&id=2030414e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030414e",
  null
  
)

export default component.exports